import React, { useEffect, useState } from 'react';
import success from '../../assets/images/success-icon.svg'
import copyButton from '../../assets/images/copy-button.svg'
import greenArrow from '../../assets/images/green-arrow.svg'
import { getLocalStorageItem } from '../../utils/localStorage';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAccountOpeningStep } from '../../redux/accountOpening';
import axios from 'axios';
import { baseUrl } from '../../utils/baseUrl';
import * as toast from '../../utils/makeToast'
import style from './style.module.css'
import { accountTypes } from '../../utils/constants';
import SuccessIcon from '../../assets/icons/SuccessIcon';



function AccountOpeningSuccessDialog(props: any) {

    const navigate = useNavigate()

    const dispatch = useDispatch()

    const [userDetails, setUserDetails] = useState(getLocalStorageItem('userDetails'))
    const [minorFirstName, setMinorFirstName] = useState<string>('')

    const [accountType, setAccountType] = useState(localStorage.getItem('altFinanceAccountType'))
    const [accountNumber, setAccountNumber] = useState<any>(localStorage.getItem('generatedAccountNumber'))

    const [accountNumberDom, setAccountNumberDom] = useState<any>()
    const [accountNumberSavingsDom, setAccountNumberSavingsDom] = useState<any>()
    const [accountStatus, setAccountStatus] = useState<any>(localStorage.getItem('accountStatus'))

    useEffect(()=>{
        if(localStorage.getItem('generatedAccountNumberDom')){
            setAccountNumberDom(JSON.parse(localStorage.getItem('generatedAccountNumberDom') || ''))
        }
    },[])

    useEffect(()=>{
        if(localStorage.getItem('generatedAccountNumberDomSavings')){
            setAccountNumberSavingsDom(JSON.parse(localStorage.getItem('generatedAccountNumberDomSavings') || ''))
        }
    },[])

    useEffect(()=>{
        if(localStorage.getItem('minorFirstName')){
            setMinorFirstName(getLocalStorageItem('minorFirstName')?.minorFirstName)
        }
    },[])


    const goToHomePage = () => {
        localStorage.clear()
        navigate("/personal-account")
    }

    const addReference = () => {
        return
        dispatch(setAccountOpeningStep('add-reference'))
    }

    const goToOpenMinorAccount = () => {
		localStorage.setItem('accountStatus', 'new')
		localStorage.setItem('altFinanceAccountType', 'Minor Savings')
        dispatch(setAccountOpeningStep('update-detail'))
        window.location.reload()
    }

    const copyAccountNumberToClipboard = (accountNumber:string) => {
        navigator.clipboard.writeText(accountNumber).then(function() {
            toast.successToast('Account number copied to clipboard')
        }, function(err) {
            toast.successToast('Account number was not copied to clipboard')
        });
    }

    const getAccountCurrency = (currency:string) => {
        if(currency.toLowerCase() == "Euro Account".toLowerCase()){
            return 'EUR'
        }
        else if(currency.toLowerCase() == "Naira Account".toLowerCase()){
            return 'NGN'
        }
        else if(currency.toLowerCase() == "USD Account".toLowerCase()){
            return 'USD'
        }
        else if(currency.toLowerCase() == "GBP Account".toLowerCase()){
            return 'GBP'
        }
    }


    return (
        <div>
            { accountType?.toLowerCase() === accountTypes.swiftSavings || accountType?.toLowerCase() === accountTypes.minorSavings ?

                <div>
                    <div className="card-body text-center">
                        <SuccessIcon/>
                        {
                            accountType?.toLowerCase() === accountTypes.swiftSavings &&
                            <h4 className="card-title text-center pl-3 mt-5">Congratulations {userDetails.firstName}, your <br /> account
                            opening was successful</h4>
                        }
                        {
                            accountType?.toLowerCase() === accountTypes.minorSavings &&
                            <h4 className="card-title text-center pl-3 mt-5">Congratulations {minorFirstName}, your <br /> account
                            opening was successful</h4>
                        }
                        <p className="text-center text-muted">
                            Here is your account number
                        </p>
                        <div className="acct_num2 container mb-4 text-center pt-3">
                            <p className={`pl-2 pr-5 ${style.account_number}`}>{accountNumber}</p>
                            <img onClick={() => copyAccountNumberToClipboard(accountNumber)} className="img-fluid pb-2 cursor-pointer" src={copyButton} alt="" />
                        </div>
                    </div>

                    <div className=" row text-center">
                        <div className="col-md-12">
                            <button className="btn btn-outline-gold mr-3 btn-filled-white" onClick={goToHomePage}>Okay</button>
                        </div>
                    </div>
                </div> : ''

            }

            {/* ------------ */}

            { accountType?.toLowerCase() === accountTypes.regularSavings || accountType?.toLowerCase() === accountTypes.jointSavings ?

                <div>
                    <div className="card-body text-center">
                        <SuccessIcon/>
                        <h4 className="card-title text-center pl-3 mt-5">Congratulations {userDetails.firstName}, your <br /> account
                            opening was successful</h4>
                        <p className="text-center text-muted">
                            Here is your account number
                        </p>
                        <div className="acct_num2 container mb-4 text-center pt-3">
                            <p className={`pl-2 pr-5 ${style.account_number}`}>{accountNumber}</p>
                            <img onClick={() => copyAccountNumberToClipboard(accountNumber)} className="img-fluid pb-2 cursor-pointer" src={copyButton} alt="" />
                        </div>
                        <div className="pt-5 mt-3 pb-3 text-muted">
                            Now that you are on the Alternative side,
                            secure your little one’s future! <br/> Open a Minor Account in just a few clicks.
                        </div>
                    </div>

                    <div className=" row text-center mb-5 pb-4">
                        <div className="col-md-12 ">
                            <button style={{marginRight:'10px'}} className="btn btn-outline-danger btn-filled-white3 mr-2 my-3"
                              onClick={goToHomePage}  >End
                            </button>
                            <button className="btn btn-danger btn-filled-red3"
                                onClick={goToOpenMinorAccount}
                                >Open Minor Account
                            </button>
                        </div>
                    </div>

                </div> : ''

            }

            {/* ---------------- */}

            {accountType?.toLowerCase() === accountTypes.domiciliarySavings ?

            <div>
                    <div className="card-body text-center">
                        <SuccessIcon/>
                        <h4 className="card-title text-center pl-3 mt-5">Congratulations {userDetails.firstName}, your account
                            opening <br/> was successful.</h4>
                        <p className="text-center text-muted">
                            Here is your account details
                        </p>
                        {accountNumberSavingsDom && accountNumberSavingsDom.map((accountNumber:any) => {
                            return (
                                <React.Fragment key={accountNumber.accountNo}>
                                    <div className="acct_num mb-4 text-center pt-3 m-auto">
                                        <div className="align-self-center py-1 px-3 mt-n3 ml-n2 mr-3 bg-white rounded-left text-dark" style={{marginRight:'10px', position:'relative', bottom:'8px'}}>
                                            <h3 className={`pt-2 ${style.currency_code}`}>{getAccountCurrency(accountNumber?.currency || accountNumber?.responseMessage)}</h3>
                                        </div>
                                        <p className={`pl-2 pr-5 ${style.account_number}`}>{accountNumber?.accountNo}</p>
                                        <img onClick={() => copyAccountNumberToClipboard(accountNumber?.accountNo)} className="img-fluid pb-2 cursor-pointer" src={copyButton} alt=""/>
                                    </div>
                                    <br/>
                                </React.Fragment>

                            )
                        })}
                        <br/>
                        
                    </div>
                    {/* <div className="text-center text-secondary">
                        <p>Proceed to add two references, Kindly ensure that the <br/> referee’s account meets the
                            following
                            requirements:</p>
                    </div>

                    <div className="container text-secondary mt-1 ml-4 mr-5">

                        <article className=" px-0 mt-0">
                            <div className="py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked" />
                                </div>
                                <span>Account has been in operation for more than 6 <br/>months.</span>
                            </div>
                        </article>
                        <article className=" px-0 mt-0">
                            <div className="py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked" />
                                </div>
                                <span>Account is not dormant</span>
                            </div>
                        </article>
                        <article className=" px-0 mt-0">
                            <div className="  py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked" />
                                </div>
                                <span>
                                    Category criteria (References from an individual account can only be <br/>
                                    used for
                                    an
                                    individual account but a reference from
                                    a registered business is suitable for all forms of
                                    current
                                    account).
                                </span>
                            </div>
                        </article>
                    </div> */}

                    <div className="row justify-content-center text-center my-5 mx-0">
                        <div className="col-sm-6 mb-3">
                            <button className="btn btn-outline-gold btn-filled-white float-md-right"
                                onClick={goToHomePage}
                                >End
                            </button>
                        </div>
                        {/* <div className="col-sm-6">
                            <button className="btn btn-filled-red float-md-left ml-md-0"
                                onClick={addReference}
                                >Add reference
                            </button>
                        </div> */}
                    </div>

            </div>
  
            : ''
            }



            {/* ------------------ */}

            {accountType?.toLowerCase() === accountTypes.current || accountType?.toLowerCase() === accountTypes.jointCurrent ?

            <div>
                    <div className="card-body text-center">
                        <SuccessIcon/>
                        <h4 className="card-title text-center pl-3 mt-5">Congratulations {userDetails.firstName}, your account
                            opening <br/> was successful.
                        </h4>
                        <p className="text-center text-muted">
                            Here is your account details
                        </p>
                        <div className="acct_num mb-4 text-center pt-3 m-auto">
                            <div className="align-self-center py-1 px-3 mt-n3 ml-n2 mr-3 bg-white rounded-left text-dark" style={{marginRight:'10px', position:'relative', bottom:'8px'}}>
                                <h3 className={`pt-2 ${style.currency_code}`}>NGN</h3>
                            </div>
                            <p className={`pl-2 pr-5 ${style.account_number}`}>{accountNumber}</p>
                            <img onClick={() => copyAccountNumberToClipboard(accountNumber)} className="img-fluid pb-2 cursor-pointer" src={copyButton} alt=""/>
                        </div>
                        <br/>
                    
                    </div>
                    {/* <div className="text-center text-secondary">
                        <p>Proceed to add two references, Kindly ensure that the <br/> referee’s account meets the
                            following
                            requirements:</p>
                    </div>

                    <div className="container text-secondary mt-1 ml-4 mr-5">

                        <article className=" px-0 mt-0">
                            <div className="py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked"/>
                                </div>
                                <span>Account has been in operation for more than 6 <br/>months.</span>
                            </div>
                        </article>
                        <article className=" px-0 mt-0">
                            <div className="py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked"/>
                                </div>
                                <span>Account is not dormant</span>
                            </div>
                        </article>
                        <article className=" px-0 mt-0">
                            <div className="  py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked"/>
                                </div>
                                <span>
                                    Category criteria (References from an individual account can only be <br/>
                                    used for
                                    an
                                    individual account but a reference from
                                    a registered business is suitable for all forms of
                                    current
                                    account).
                                </span>
                            </div>
                        </article>
                    </div> */}

                    <div className="row justify-content-center text-center my-5 mx-0">
                        <div className="col-sm-6 mb-3">
                            <button className="btn btn-outline-gold btn-filled-white float-md-right"
                                onClick={goToHomePage}
                                >End
                            </button>
                        </div>
                        {/* <div className="col-sm-6">
                            <button className="btn btn-filled-red float-md-left ml-md-0"
                                onClick={addReference}
                                >Add reference
                            </button>
                        </div> */}
                    </div>

            </div>

            : ''
            }

            {/* --------------- */}

            { accountType?.toLowerCase() === accountTypes.domiciliaryCurrent ?

            <div>
                    <div className="card-body text-center">
                        <SuccessIcon/>
                        <h4 className="card-title text-center pl-3 mt-5">Congratulations {userDetails.firstName}, your account
                            opening <br/> was successful.
                        </h4>
                        <p className="text-center text-muted">
                            Here is your account details
                        </p>   

                        {accountNumberDom && accountNumberDom.map((accountNumber:any) => {
                            return (
                                <React.Fragment key={accountNumber.accountNo}>
                                    <div className="acct_num mb-4 text-center pt-3 m-auto">
                                        <div className="align-self-center py-1 px-3 mt-n3 ml-n2 mr-3 bg-white rounded-left text-dark" style={{marginRight:'10px', position:'relative', bottom:'8px'}}>
                                            <h3 className={`pt-2 ${style.currency_code}`}>{accountNumber.currency}</h3>
                                        </div>
                                        <p className={`pl-2 pr-5 ${style.account_number}`}>{accountNumber?.accountNo}</p>
                                        <img onClick={() => copyAccountNumberToClipboard(accountNumber?.accountNo)} className="img-fluid pb-2 cursor-pointer" src={copyButton} alt=""/>
                                    </div>
                                    <br/>
                                </React.Fragment>

                            )
                        })}
                    
                    </div>
                    {/* <div className="text-center text-secondary">
                        <p>Proceed to add two references, Kindly ensure that the <br/> referee’s account meets the
                            following
                            requirements:</p>
                    </div>

                    <div className="container text-secondary mt-1 ml-4 mr-5">

                        <article className=" px-0 mt-0">
                            <div className="py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked"/>
                                </div>
                                <span>Account has been in operation for more than 6 <br/>months.</span>
                            </div>
                        </article>
                        <article className=" px-0 mt-0">
                            <div className="py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked"/>
                                </div>
                                <span>Account is not dormant</span>
                            </div>
                        </article>
                        <article className=" px-0 mt-0">
                            <div className="  py-1 d-flex">
                                <div className=" mr-2" style={{marginRight:'10px'}}>
                                    <img className="marker" src={greenArrow} alt="checked"/>
                                </div>
                                <span>
                                    Category criteria (References from an individual account can only be <br/>
                                    used for
                                    an
                                    individual account but a reference from
                                    a registered business is suitable for all forms of
                                    current
                                    account).
                                </span>
                            </div>
                        </article>
                    </div> */}

                    <div className="row justify-content-center text-center my-5 mx-0">
                        <div className="col-sm-6 mb-3">
                            <button className="btn btn-outline-gold btn-filled-white float-md-right"
                                onClick={goToHomePage}
                                >End
                            </button>
                        </div>
                        {/* <div className="col-sm-6">
                            <button className="btn btn-filled-red float-md-left ml-md-0"
                                onClick={addReference}
                                >Add reference
                            </button>
                        </div> */}
                    </div>

            </div>

            : ''
            }




        </div>
    );
}

export default AccountOpeningSuccessDialog;